import { z } from "zod";

export const newIntakeFormSchema = z.object({
  leadSourceName: z.string().min(1, { message: "Lead source is required" }),
  listId: z.string().min(1, { message: "List id is required" }),
  firstName: z
    .string()
    .min(1, { message: "First name is required" })
    .max(20, { message: "First name must be less than 20 characters" }),
  lastName: z
    .string()
    .min(1, { message: "Last name is required" })
    .max(20, { message: "Last name must be less than 20 characters" }),
  email: z
    .string()
    .email("Email is invalid")
    .transform((email) => email.toLowerCase()),
  phoneNumber: z
    .string()
    .length(10, { message: "Cell phone must be a 10-digit number" }),
  month: z
    .number()
    .min(1, { message: "Month must be between 1 and 12" })
    .max(12, { message: "Month must be between 1 and 12" }),
  day: z
    .number()
    .min(1, { message: "Day must be between 1 and 31" })
    .max(31, { message: "Day must be between 1 and 31" }),
  year: z.number().min(1900, { message: "Year must be after 1900" }),
  vendorId: z.string().optional(),
});

export type NewIntakeFormInputType = z.infer<typeof newIntakeFormSchema>;
